export enum StorageKey {
  Language = 'lng',
}
